import type { ResultOf } from '@graphql-typed-document-node/core';
import { graphql } from 'src/gql';

export const ClientPortalFundingStateQuery = graphql(`
  query ClientPortalFundingState($householdId: ID) {
    householdFundingState(householdId: $householdId) {
      householdId
      phase
      accounts {
        accountId
        transferState
        settledAt
        funded
        terminal
      }
    }
  }
`);

export type ClientPortalFundingStateResult = ResultOf<typeof ClientPortalFundingStateQuery>;

export type ClientPortalAccountFundingState =
  ClientPortalFundingStateResult['householdFundingState']['accounts'][number];
